// For more details: https://stackoverflow.com/questions/32553158/detect-click-outside-react-component

import { useEffect } from 'react';

export function useOutsideClickCallback({ ref, cb }) {
  useEffect(() => {
    function handleClickOutside(event) {
      if (ref.current && !ref.current.contains(event.target)) {
        cb();
      }
    }
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [ref]);
}
